export default __webpack_public_path__ + "static/media/md.36526cb5.svg";